import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { useTranslation } from 'react-i18next'
import api from '../../api/api';
import { toast } from 'react-toastify';
import { useProfileStore } from '../../store/useUserStore';
import { formatDate } from '../../helpers/helper';

const StudentReport = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [reports, setReports] = useState<any>([])
  const {setLoading} = useProfileStore();

  useEffect(() => {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_API_BASE_URL}/parent/student_report`)
      .then((res) => {
        console.log("res student report", res.data.data);
        setReports(res.data.data);
      })
      .catch((err) => {
        toast.error(t("server_error"));
        console.log("err student report", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function openReport(reportId:number) {
        setLoading(true)
        api.post(`${process.env.REACT_APP_API_BASE_URL}/parent/mark-student-report-seen/${reportId}`).then(res => {
            console.log("mark seen", res.data)
        }).catch(err => {
            console.log("err mark seen", err)
        }).finally(()=>{
            setLoading(false)
            navigate(`/student-report/${reportId}`)
        })
    }


  return (
    <div className="pb-2 py-2">
      {/* Header */}
        <div className='mb-4 grid grid-cols-4 px-4 pt-2'>
            <div><IoIosArrowBack size={28} color='#000' onClick={()=>navigate("/inbox")}/></div>
            <div className='text-center col-span-2 text-lg font-medium'>Student Report</div>
            <div></div>
        </div>
        

        <div className="pb-2 py-2">
            {reports.map((report:any, index:number) => {
                return (
                    <div key={index} className='grid grid-cols-12 gap-2 mx-2  p-2.5 items-center rounded-3xl mb-3 shadow-md' onClick={()=>{openReport(report.id)}}>
                        <div className='col-span-2'>
                            <img src={report.coach_academy_profile_pic || "/assets/img/koku-logo.png"} alt="" className='w-10 h-10 rounded-3xl'/>
                        </div>
                        <div className='col-span-6'>
                            <div className={`text-md truncate ${report.is_parent_read === false ? 'font-semibold' : 'font-light'}`}>{report.title || "-"}</div>
                            <div className={`text-md font-light truncate`}>{report.student_name || "-"}</div>
                        </div>
                        <div className={`col-span-4 text-xs ${report.is_parent_read === false ? 'font-semibold' : 'font-light'} self-start`}>{report.sent_at ? formatDate(report.created_at) : "-"}</div>
                    </div>
                )
            })}
            
        </div>
    </div>
  );
};

export default StudentReport;
